import React from "react";
import {
	InputLabel,
	Button,
	Grid,
	Theme,
	Typography,
	DialogContent,
	DialogActions,
	Slide,
	Grow
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { useTranslation, Trans } from "react-i18next";
import { TextInput } from "../../Forms/Inputs";
import Title from "./Title";

const useStyles = makeStyles((theme: Theme) => ({
	root: {
		width: "100%",
		maxWidth: 600,
	},
	heading: {
		fontSize: 15,
		fontWeight: theme.typography.fontWeightRegular,
	},
	header: {
		backgroundColor: theme.palette.primary.main,
		color: "white",
		borderTopLeftRadius: "5px",
		borderTopRightRadius: "5px",
		fontSize: 22,
		lineHeight: 1,
		margin: 0,
	},
	avatar: {
		height: 70,
		width: 70,
		marginLeft: 20,
	},
	accordion: {
		padding: 20,
	},
	cardHeader: {
		backgroundColor: theme.palette.primary.main,
		color: "white",
		alignItems: "flex-start",
		width: "100%",
	},
	margin: {
		marginBottom: 0,
		[theme.breakpoints.up("md")]: {
			marginTop: 32,
		},
	},
	headerColor: {
		color: "white",
	},
}));

export default function HealthInfo(props: any) {
	const classes = useStyles();
	useTranslation();

	const user: any = {
		importantInformation: "",
		insuranceCompany: "",
		insuranceId: "",
		emergencyName: "",
		emergencyNumber: "",
		emergencyName2: "",
		emergencyNumber2: ""
	}
	let healthInfo = {
		disclose: user.importantInformation,
		insCompany: user.insuranceCompany,
		insId: user.insuranceID,
		emergencyName: user.emergencyContact1,
		emergencyNumber: user.phone1,
		emergencyName2: user.emergencyContact2,
		emergencyNumber2: user.phone2,
	};
	const [values, setValues] = React.useState(healthInfo);

	const handleChange = (event: any) => {
		setValues({
			...values,
			[event.target.name]: event.target.value,
		});
	};
	const handleUpdate = () => {
		props.onClose();
	};

	let disabled: any;
	if (
		!values.insId &&
		!values.insCompany &&
		!values.disclose &&
		!values.emergencyName &&
		!values.emergencyNumber &&
		!values.emergencyName2 &&
		!values.emergencyNumber2
	) {
		disabled = true;
	}

	const inputStyle: any = {
		input: { color: 'primary.contrastText', backgroundColor: "#252525", borderRadius: 2 }
	}
	return (
		<>

			<Title title="Health Information" onClose={props.onClose} />
			<DialogContent>
				<Grid container spacing={2}>
					<Grid item xs={12}>
						<InputLabel>
							<Typography
								variant="h6"
								color="secondary"
								sx={{ input: { color: 'primary.contrastText' }, pt: 1 }}

								className={classes.headerColor}
							>
								Emergency Contacts:
							</Typography>
						</InputLabel>
					</Grid>
					<Grid item xs={12}>
						<InputLabel className={classes.headerColor}>
							<i>Emergency Contact 1</i>
						</InputLabel>
					</Grid>
					<Grid item md={6} xs={12}>
						<TextInput
							color="secondary"
							sx={inputStyle}
							label="Full Name"
							fullWidth
							name="emergencyName"
							onChange={handleChange}
							value={values.emergencyName}
						/>
					</Grid>
					<Grid item md={6} xs={12}>
						<TextInput
							fullWidth
							color="secondary"
							sx={inputStyle}
							label={<Trans>Phone Number</Trans>}
							name="emergencyNumber"
							onChange={handleChange}
							value={values.emergencyNumber}
						/>
					</Grid>
					<Grid item xs={12}>
						<InputLabel className={classes.headerColor}>
							<i>Emergency Contact 2</i>
						</InputLabel>
					</Grid>
					<Grid item md={6} xs={12}>
						<TextInput
							label={<Trans>Full Name</Trans>}
							fullWidth
							color="secondary"
							sx={inputStyle}
							name="emergencyName2"
							onChange={handleChange}
							value={values.emergencyName2}
						/>
					</Grid>
					<Grid item md={6} xs={12}>
						<TextInput
							fullWidth
							color="secondary"
							sx={inputStyle}
							label={<Trans>Phone Number</Trans>}
							name="emergencyNumber2"
							onChange={handleChange}
							value={values.emergencyNumber2}
						/>
					</Grid>
					{/* </div> */}
				</Grid>
				<Grid container spacing={2}>
					<Grid item xs={12}>
						<InputLabel>
							<Typography
								sx={{ mt: 2 }}
								variant="h6"
								className={classes.headerColor}
							>
								Health Insurance:
							</Typography>
						</InputLabel>
					</Grid>
					<Grid item md={6} xs={12}>
						<TextInput
							fullWidth
							label={<Trans>Company Name</Trans>}
							color="secondary"
							sx={inputStyle}
							name="insCompany"
							onChange={handleChange}
							value={values.insCompany}
						/>
					</Grid>
					<Grid item md={6} xs={12}>
						<TextInput
							fullWidth
							color="secondary"
							sx={inputStyle}
							label={<Trans>Insurance ID</Trans>}
							name="insId"
							onChange={handleChange}
							value={values.insId}
						/>
					</Grid>
					<Grid item xs={12}>
						<InputLabel style={{ marginBottom: 10 }}>
							<Typography color="secondary"
								sx={inputStyle} variant="h6" className={classes.headerColor}>
								Additional Information:
							</Typography>
						</InputLabel>
						<InputLabel
							style={{
								lineHeight: "1.5rem",
								color: "white",
								whiteSpace: "normal",
							}}
						>
							<Trans>
								<i>
									Do you wish to share anything about your health that may
									impact your performance?
								</i>
							</Trans>
						</InputLabel>
						<br />
						<TextInput
							fullWidth
							name="disclose"
							multiline
							color="secondary"
							sx={inputStyle}
							rows={4}
							onChange={handleChange}
							required
							value={values.disclose}
						/>
					</Grid>
				</Grid>
			</DialogContent>
			<DialogActions sx={{ p: 2 }}>
				<Button
					fullWidth
					onClick={() => props.onClose()}
					color="secondary"
					variant="outlined"
					sx={{ mr: 1 }}
				>
					<Trans>Cancel</Trans>
				</Button>
				<Button
					fullWidth
					onClick={() => handleUpdate()}
					color="secondary"
					variant="contained"
					disabled={disabled}
					sx={{ ml: 1 }}
				>
					<Trans>Save</Trans>
				</Button>
			</DialogActions>
		</>
	);
}
